import { Labels } from "../model/Labels.js";
import { DiamondButton } from "./DiamondButton.js";
import { Mixer } from "./Mixer.js";
import { Polygon } from "./Polygon.js";

export interface MixerResetOptions {
    container: HTMLElement;
    mixer: Mixer;
    labels: Labels;
}

export class MixerReset {

    private _element: HTMLDivElement;
    private _options: MixerResetOptions;
    private _mixer: Mixer;
    private _visible: boolean = false;

    constructor(options: MixerResetOptions) {

        options = e5.object.merge({
        } as MixerResetOptions, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "mixer-reset mixer-reset--hidden e5-hidden";
        this._element.innerHTML = `
            <div class="mixer-reset__background"></div>
            <div class="mixer-reset__content">
                <div class="mixer-reset__message">${options.labels.html("orchestra.mixer_reset.message")}</div>
                <div class="mixer-reset__mixer">
                    <div class="mixer-reset__mixer-center">
                        <div class="mixer-reset__mixer-center-arrow e5 icon-682"></div>
                        <div class="mixer-reset__mixer-center-line"></div>
                        <div class="mixer-reset__mixer-center-arrow e5 icon-723"></div>
                    </div>
                </div>
                <div class="mixer-reset__control"></div>
            </div>`;

        new Polygon({
            shape: "13",
            container: this._element.querySelector(".mixer-reset__content"),
            prepend: true,
            shadow: true,
            gradient: false
        });

        this._mixer = new Mixer({
            container: this._element.querySelector(".mixer-reset__mixer"),
            style: "comic",
            position: "relative",
            mixer: options.mixer
        });

        new DiamondButton({
            container: this._element.querySelector(".mixer-reset__control"),
            label: options.labels.text("orchestra.mixer_reset.button"),
            onClick: () => {
                this.visible = false;
            }
        });


        e5.on({
            type: "click",
            scope: this._element,
            selector: ".mixer-reset__background",
            listener: (e) => {
                this.visible = false;
            }
        });

        // this.updateFaderStates();

        this._mixer.onChange.throttle((states) => {

            // this.updateFaderStates();
            if (!this._visible) {
                return;
            }

            this.hideIfAligned();
        }, 100);

        options.container.appendChild(this._element);

        this._element.addEventListener("transitionend",
            () => {
                if (!this.visible) {
                    this._element.classList.add("e5-hidden");
                }
            });
    }

    private updateFaderStates(): void {
        for (let f of this._mixer.faders) {
            f.element.style.opacity = this.isAligned(f.volume) ? "1" : "0.5";
        }
    }

    public showIfMisaligned(): void {
        if (!this.isAlignedAll()) {
            this.visible = true;
        }
    }

    private hideIfAligned(): void {
        if (this.isAlignedAll()) {
            this.visible = false;
        }
    }

    private isAligned(volume: number): boolean {
        const range = 0.3;
        return !(volume < (0.5 - range * 0.5)
            || volume > (0.5 + range * 0.5));
    }

    private isAlignedAll(): boolean {
        for (let fader of this._mixer.faders) {
            if (!this.isAligned(fader.volume)) {
                return false;
            }
        }
        return true;
    }

    public get visible(): boolean {
        return this._visible;
    }

    public set visible(value: boolean) {
        if (this._visible === value) {
            return;
        }
        this._visible = value;


        if (value) {
            this._element.classList.remove("e5-hidden");
            this._element.offsetWidth;
        }

        this._element.classList.toggle("mixer-reset--hidden", !value);
    }
}